const ScorersTable = () => {
  return <div></div>;
};

export default ScorersTable;
